import { LOCATION_CHANGE } from 'store/location'

export const ADD_NEW_SEARCH_BAR = 'ADD_NEW_SEARCH_BAR'
export const SEARCH_BAR_CHANGED = 'SEARCH_BAR_CHANGED'
export const SEARCH_BAR_SEARCH = 'SEARCH_BAR_SEARCH'

export interface ISearchBarAction {
  type: string
  payload: {
    id: string
    value: any
  }
}

interface ISearchBar {
  searchBarCurrentText: string
  searchBarSearchText: string
}

export interface ISearchBarState {
  [id: string]: ISearchBar
}

const initialState: ISearchBarState = {}
export const searchBarReducer = (state: ISearchBarState = initialState, action: ISearchBarAction): ISearchBarState => {
  switch (action.type) {
    case ADD_NEW_SEARCH_BAR:
      return {
        ...state,
        [action.payload.id]: { searchBarCurrentText: '', searchBarSearchText: '' },
      }
    case SEARCH_BAR_CHANGED:
      if (action.payload.value === '') {
        return {
          ...state,
          [action.payload.id]: {
            ...state[action.payload.id],
            searchBarSearchText: '',
            searchBarCurrentText: '',
          },
        }
      } else {
        return {
          ...state,
          [action.payload.id]: {
            ...state[action.payload.id],
            searchBarCurrentText: action.payload.value,
          },
        }
      }
    case SEARCH_BAR_SEARCH:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          searchBarSearchText: action.payload.value,
        },
      }
    case LOCATION_CHANGE:
      return state
    default:
      return state
  }
}
